import { QueryHookOptions } from '@apollo/client';
import { useGetAlertMetrics, useGetProjectCampaignAlerts } from 'modules/campaigns/alerts/hooks';
import { FC, ReactNode, useMemo } from 'react';
import { getFormInitialValues } from './AlertsFormProvider.utils';
import { ProjectAlertsContext, ProjectAlertsContextState } from './ProjectAlertsContext';

type Props = {
  children: ReactNode;
  queryOptions?: QueryHookOptions;
};

const METRICS_QUERY_OPTIONS = {
  variables: { page: 'CampaignPerformanceAlerts' },
};

export const ProjectAlertsProvider: FC<Props> = ({ children, queryOptions = {} }) => {
  const { allAlertMetrics, isLoadingMetrics } = useGetAlertMetrics(METRICS_QUERY_OPTIONS);

  const { savedAlerts, setSavedAlerts, isLoadingProjectCampaignAlerts } =
    useGetProjectCampaignAlerts(queryOptions);

  const defaultValues = useMemo(() => {
    if (!isLoadingProjectCampaignAlerts && !isLoadingMetrics) {
      return getFormInitialValues(allAlertMetrics, savedAlerts);
    }
  }, [allAlertMetrics, isLoadingMetrics, isLoadingProjectCampaignAlerts, savedAlerts]);

  const value: ProjectAlertsContextState = {
    defaultValues,
    allAlertMetrics,
    savedAlerts,
    setSavedAlerts,
    isLoadingMetrics,
    isLoadingProjectCampaignAlerts,
  };

  return <ProjectAlertsContext.Provider value={value}>{children}</ProjectAlertsContext.Provider>;
};
